"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tsParticles = exports.pJSDom = exports.particlesJS = void 0;

var tslib_1 = require("tslib");

var pjs_1 = require("./pjs");

var main_1 = require("./main");

var tsParticles = new main_1.Main();
exports.tsParticles = tsParticles;
tsParticles.init();

var _pjs_1$initPjs = pjs_1.initPjs(tsParticles),
    particlesJS = _pjs_1$initPjs.particlesJS,
    pJSDom = _pjs_1$initPjs.pJSDom;

exports.particlesJS = particlesJS;
exports.pJSDom = pJSDom;

tslib_1.__exportStar(require("./Enums"), exports);